import { useUser } from "reactfire";
import "react-datepicker/dist/react-datepicker.css";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import { Share } from "@capacitor/share";
import { FirebaseDynamicLinks } from "@pantrist/capacitor-firebase-dynamic-links";
import { IonButton, IonLabel } from "@ionic/react";
import { useLeague } from "context/leagueContext";
import { useTranslation } from "react-i18next";

export default function SendInvite() {
  const { status, data: user } = useUser();
  const { t } = useTranslation();

  const {
    state: { leagueInfo },
  } = useLeague();

  const callSendInvite = async (referredBy, leagueId, e) => {
    e.preventDefault();

    let shortlink = await createShortLinks(referredBy, leagueId);

    await Share.share({
      title: "Try out Predictably",
      text: "Try out Predictably",
      url: shortlink,
      dialogTitle: "Share with",
    });
  };

  return (
    <IonButton
      color="dark"
      mode="ios"
      fill="solid"
      expand="block"
      // disabled={isSubmitting}
      onClick={(e) => callSendInvite(user.uid, leagueInfo?.id, e)}
      className="customButtonNew rounded-md h-10 w-full"
    >
      <IonLabel>{t("tournament.invite.title")}</IonLabel>
      <IonLabel slot="start">
        <PaperAirplaneIcon className="h-6 w-6 mr-2  " />
      </IonLabel>
    </IonButton>
  );
}

async function createShortLinks(referredBy, leagueId) {
  const config = {
    domainUriPrefix: "https://prediction.page.link",
    webApiKey: "AIzaSyBLdGIZBrR3nQFqlQd85bKOUr_UGC1U65M",

    uri:
      "https://prediction.page.link/?referredBy=" +
      referredBy +
      "&leagueId=" +
      leagueId,
    androidParameters: {
      packageName: "com.olelillebo.prediction",
    },
    iosParameters: {
      bundleId: "com.olelillebo.prediction",
    },
  };
  return FirebaseDynamicLinks.createDynamicShortLink(config).then(
    (link) => link.value
  );
}
